import React, {useEffect, useState} from "react";
import {Link, useHistory} from "react-router-dom";
import {
    Avatar,
    Badge,
    Button,
    Card,
    Col,
    Drawer,
    Dropdown,
    Menu,
    message,
    notification,
    Row,
    Space,
    Statistic,
    theme,
    Tooltip,
    Typography,
} from "antd";
// import type { MenuProps } from 'antd';
import Layout from "antd/es/layout";
import "./style.scss";
import {
    CaretDownOutlined,
    DownOutlined,
    MenuFoldOutlined,
    MenuUnfoldOutlined,
    UserOutlined,
} from "@ant-design/icons/lib";
import {useKeycloak} from "@react-keycloak/web";
import {
    faBell,
    faCakeCandles,
    faEnvelope,
    faIdCard,
    faLock,
    faPhone,
    faQuestion,
    faUser,
    faUserTie
} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {deleteDeviceToken, getUserToken, onMessageListener} from "../../../util/firebase";
import notificationService from "../../../service/notificationService";
import ErrorHandler from "../../../util/ErrorHandler";
import JointAccountTemplateRequest from "../jointAccountTemplate/jointAccountTemplateRequestModal";
import customerService from "../../../service/customerService";
import {UserProfileDto} from "../../../dto/UserProfileDto";
import {MSG_FAILED_TO_FETCH_DOCUMENTS_ERROR, MSG_FAILED_TO_FETCH_USER_PROFILE_DTO_ERROR} from "../../../util/Messages";
import CommonFunction from "../../../util/CommonFunction";
import dayjs from "dayjs";
import {DOC_CODE_PROFILE_PIC, NOT_AVAILABLE, YYYY_MM_DD} from "../../../util/Constants";
import documentService from "../../../service/documentService";
import {UploadedDocumentDetailDto} from "../../../dto/UploadedDocumentDetailDto";
import {toNumber} from "lodash";
import modal from "antd/es/modal";
import {ExclamationCircleOutlined, LogoutOutlined} from "@ant-design/icons";
import {getLoggedUserId, isCustomer} from "../../../security/KeyclockConfig";
import IdleTimeComp from "../idleTimer/IdleTimeComp";
import ClientHttpService from "../../../util/ClientHttpService";

const {Paragraph} = Typography;
const {useToken} = theme;

type NotificationType = 'success' | 'info' | 'warning' | 'error';
const {Header} = Layout;
const redirectUri: string | undefined = process.env.REDIRECT_URI ? process.env.REDIRECT_URI : "http://localhost:3000/";

interface NotificationData {
    notificationId: number
    message: string
    readNotification: boolean
    title: string
    businessFlowName: string
}

interface NotificationDataWrapperDto {
    unReadCount: number
    totalCount: number
    notificationList: NotificationData[]
}

const PageHeader: React.FC<{ toggle: any; collapsed: any, changeTheme: any, logoutClicked: () => void }> = ({
                                                                                                                toggle,
                                                                                                                collapsed,
                                                                                                                changeTheme,
                                                                                                                logoutClicked
                                                                                                            }) => {

    const {keycloak} = useKeycloak();
    const keycloakToken: any = keycloak.tokenParsed;
    const preferredUsername = keycloakToken?.preferred_username;
    const [open, setOpen] = useState(false);
    const [openProfileDrawer, setProfileDrawerOpen] = useState(false);


    const [deviceToken, setDeviceToken] = useState("");
    const [notificationInfo, setNotification] = useState({title: '', body: ''});
    const [allNotification, setAllNotification] = useState<NotificationDataWrapperDto>({
        unReadCount: 0,
        totalCount: 0,
        notificationList: []
    });
    const [unReadCount, setUnreadNotificationCount] = useState(0);
    const [userProfileDto, setUserProfileDto] = useState<UserProfileDto>();
    const [uploadedDocument, setUploadedDocument] = useState<UploadedDocumentDetailDto>();
    const [isLoggedUserRoleCustomer, setLoggedUserRoleCustomer] = useState(false);

    const [api, contextHolder] = notification.useNotification();
    let history = useHistory();

    onMessageListener().then((payload: any) => {
        let priorityStatus = payload.data.priorityStatus;
        let notifyType: any = "success";
        if (priorityStatus == 'HIGH') {
            notifyType = "error";
        } else if (priorityStatus == 'LOW') {
            notifyType = "info";
        } else {
            notifyType = "warning";
        }
        setNotification({title: payload.notification.title, body: payload.notification.body})
        openNotificationWithIcon(notifyType, {
            title: payload.notification.title,
            body: payload.notification.body,
            username: payload.data.username
        });
    }).catch(err => console.log('failed: ', err));

    const openNotificationWithIcon = (type: NotificationType, msgPayload: any) => {
        api[type]({
            message: `${msgPayload.title}`,
            description:
                `${msgPayload.body}`,
        });
    };

    useEffect(() => {
        if (isCustomer()) {
            setLoggedUserRoleCustomer(true)
            getUserProfileDetail()

            if ('Notification' in window) {
                Notification.requestPermission().then((permission) => {
                    if (permission === "granted") {
                        console.log("Notification User Permission Granted.");
                        deleteDeviceToken().then(value => {
                            console.log("Delete Device Token ", value)
                            getUserToken().then(response => {
                                console.log("TOKEN :", response);
                                setDeviceToken(response);
                                notificationService.updateFirebaseToken(preferredUsername, response).then(value => {
                                    console.log("Device token has been updated ", value)
                                }).catch(reason => console.log(reason))

                            }, reason => {
                                window.location.reload();

                            });
                        }).catch(reason => console.log(reason))

                    } else {
                        console.log("User Permission Denied.");

                    }
                }).catch(reason => console.log(reason));
            } else {
                console.log("Notifications are not supported in this browser.");
            }
        } else {
            setLoggedUserRoleCustomer(false)
        }
        getAllNotification()
    }, []);

    const logout = () => {
        modal.confirm({
            title: 'Confirm',
            icon: <ExclamationCircleOutlined/>,
            className: 'confirm-dialog-box',
            content: `Are you sure you want to logout?`,
            okText: 'Yes',
            cancelText: 'No',
            okButtonProps: {style: {background: '#FF7400'}},
            onOk() {
                userLogoutFunc()
            },
        });

    };

    const userLogoutFunc = () => {
        /*keycloak.logout({
            redirectUri: window.location.origin, // Redirect after logout
        });*/
        logoutClicked()
        if (isCustomer()) {
            notificationService.revokeFirebaseToken(preferredUsername).then(value => {
                //keycloak.logout({redirectUri: !isLoggedUserRoleCustomer ? redirectUri?.concat("admin") : redirectUri});
                keycloak.logout({redirectUri: window.location.origin});
                clearSpecificItems();
            }).catch(reason => {
                console.log(reason);
                //keycloak.logout({redirectUri: !isLoggedUserRoleCustomer ? redirectUri?.concat("admin") : redirectUri})
                keycloak.logout({redirectUri: window.location.origin})
                clearSpecificItems();
            });
        } else {
            keycloak.logout({redirectUri: window.location.origin});
            clearSpecificItems();
        }
        ClientHttpService.logoutAllUserRelatedSessions(getLoggedUserId() as string).then((result => {
            console.log(result)
        }))

    }


    const clearSpecificItems = (): void => {
        const keysToRemove: string[] = [
            "workBasketData",
            "adminClickedCin",
            "managerCode",
            "rmCode",
            "cinNumber",
        ];

        keysToRemove.forEach((key) => {
            if (localStorage.getItem(key) !== null) {
                localStorage.removeItem(key);
            }
        });
    };
    const showDrawer = () => {
        setOpen(true);
    };
    const showProfileDrawer = () => {
        setProfileDrawerOpen(true);
    };
    const onProfileDrawerClose = () => {
        setProfileDrawerOpen(false);
    };
    const getAllNotification = () => {
        if (isCustomer()) {
            customerService.getAllNotification().then((res: any) => {
                setAllNotification(res.data.results)
            }).catch(reason => {
                console.log(reason);
            });
        }
    }
    const getUserProfileDetail = () => {
        customerService.getUserProfileDetail().then((res: any) => {
            if (res.data !== null) {
                let results = res.data.results;
                setUserProfileDto(results)
                fetchProfilePicture(results)
            } else {
                message.error(MSG_FAILED_TO_FETCH_USER_PROFILE_DTO_ERROR).then();
            }

        }).catch(reason => {
            ErrorHandler.handleError(reason);
            console.log(reason);
        });
    }

    const fetchProfilePicture = (data: UserProfileDto) => {

        if (null != data && null != data.jobNumber) {
            documentService.getUploadDocumentListByType(toNumber(data.jobNumber), [DOC_CODE_PROFILE_PIC]).then(res => {
                if (res.data !== null) {
                    setDocuments(res.data.results)
                } else {
                    message.error(MSG_FAILED_TO_FETCH_DOCUMENTS_ERROR).then();
                }
            }, (reason) => {
                ErrorHandler.handleError(reason);
            })
        }
    }
    const setDocuments = (documentList: [] | undefined) => {
        if (undefined != documentList) {
            documentList.map((document: any) => {
                let uploadDocumentDetailDto: UploadedDocumentDetailDto = document.uploadDocumentDetailDto;

                if (null != uploadDocumentDetailDto) {
                    setUploadedDocument(uploadDocumentDetailDto)
                }
            })
        }
    };
    const onClose = () => {
        setOpen(false);
    };

    const viewJointAccountRequests = (flowName: string, id: number) => {

        customerService.markAsReadNotification(id).then((res) => {
            getAllNotification();
            if (flowName === "sendJointAccounttemplateAccept") {
                history.push('/workflow/customer/joint-account-template-request-list')
                setOpen(false)

            } else if (flowName === "sendJointAccountRequestNotification") {
                history.push('/workflow/customer/joint-account-request-list')
                setOpen(false)

            }
        }, (reason) => {
            console.log(reason)
        })

    }

    const markAllAsRead = () => {

        customerService.markAllAsReadNotification().then((res) => {
            console.log(res)
            if (res.data !== null) {
                message.success("All notifications have been marked as read.")
            } else {
                message.error("Failed to mark notifications as read. Please try again later.").then();
            }
            getAllNotification();
        }, (reason) => {
            console.log(reason)
        })

    }

    const {token} = useToken();
    const renderContent = (userProfileDto: UserProfileDto) => (

        <div className="relationship-manager-info">
            <span>{undefined != userProfileDto ? CommonFunction.validateText(userProfileDto.relationshipManager) : "N/A"}</span>
            {/*<span className="rm-phone-no">077 556 25 24</span>*/}
        </div>
    );

    const onChangePasswordClick = () => {
        history.push("/workflow/customer/change-password")
        onProfileDrawerClose()
    }

    const redirectToFAQ = () => {
        window.open("https://ndbwealth.com", "_blank");
    }
    return (
        /*Header Section*/
        <>
            {contextHolder}
            <Header className={"site-header" + " " + token.modeIconClass}>
                <Row>
                    <Col>
                        {React.createElement(
                            collapsed ? MenuUnfoldOutlined : MenuFoldOutlined,
                            {
                                className: "trigger",
                                onClick: toggle,
                                /* style: {color: "#fff"}*/
                            }
                        )}
                    </Col>
                    <h3 className='header-title'>
                        Wealth Management Portal
                    </h3>

                    <Col>
                        <div className="site-user">
                            {/*{isLoggedUserRoleCustomer ?*/}
                            {/*    <div className='faq-container'>*/}
                            {/*        <Tooltip title={"FAQ"} placement='bottom'>*/}
                            {/*            <div onClick={redirectToFAQ}>*/}
                            {/*                <Avatar shape="circle">*/}
                            {/*                    <div className="mode-icon">*/}
                            {/*                        <FontAwesomeIcon className='fq-icon' icon={faQuestion}/>*/}
                            {/*                    </div>*/}
                            {/*                </Avatar>*/}
                            {/*            </div>*/}
                            {/*        </Tooltip>*/}
                            {/*    </div> : <></>}*/}
                            <div className="mode-switch">
                                <Tooltip title={token.modeToolTip} placement='bottom'>

                                    <div className={"mode-switcher " + token.modeIconClass} onClick={changeTheme}>
                                        <Avatar shape="circle" size="large">
                                            <div className="mode-icon">
                                                <FontAwesomeIcon className='mode-icon-fa' icon={token.modeIcon}/>
                                            </div>
                                        </Avatar>
                                    </div>
                                </Tooltip>
                            </div>
                            {isLoggedUserRoleCustomer ?
                                <div className='notification-icon'>
                                    <Badge count={allNotification.unReadCount} overflowCount={99} size="small">
                                        <Avatar shape="circle" onClick={showDrawer}>
                                            {/*<BellOutlined className='bell-icon'/>*/}
                                            <FontAwesomeIcon className='bell-icon' icon={faBell}/>
                                            {/*<Button shape="circle" icon={<BellOutlined />} />*/}
                                        </Avatar>
                                    </Badge>
                                </div>
                                :
                                <></>}
                            <div className={"user-profile"}>
                                <Dropdown overlay={
                                    <Menu className='user-menu' expandIcon={<DownOutlined/>}>
                                        {isLoggedUserRoleCustomer ?
                                            <Menu.Item style={{display: "block"}}>
                                                <Link to="#" onClick={showProfileDrawer}>
                                                    <UserOutlined/> My Profile
                                                </Link>
                                            </Menu.Item> : <></>}
                                        <Menu.Item style={{display: "block"}}>
                                            <Link to="#" onClick={() => {
                                                logout();
                                            }}>
                                                <LogoutOutlined/> Logout
                                            </Link>
                                        </Menu.Item>
                                    </Menu>
                                }>
                                    <a className="ant-dropdown-link">
                                        <span className="site-user-auth">{preferredUsername}</span>
                                        {/*<Avatar className='user-avatar-icon' icon={<UserOutlined/>}/>*/}
                                        {undefined != uploadedDocument ?
                                            <Avatar className='user-avatar-icon' icon={<UserOutlined/>}
                                                    src={uploadedDocument?.thumbB64}/>
                                            :
                                            <Avatar className='user-avatar-icon' icon={<UserOutlined/>}/>}
                                        <CaretDownOutlined/>
                                    </a>
                                </Dropdown>
                            </div>
                        </div>
                    </Col>
                </Row>

                <Drawer className={'user-profile-drawer'}
                        title={[
                            <div className={'profile-drawer'}>
                                {undefined != uploadedDocument ?
                                    <Avatar size={64} src={uploadedDocument?.thumbB64}/>
                                    :
                                    <Avatar size={64} icon={<UserOutlined/>}/>}
                                <div className={'profile-name-cin'}>
                                        <span className={'customer-name'}>
                                            {CommonFunction.validateText(userProfileDto?.customerName)}
                                        </span>
                                    <span className={'customer-cin'}>
                                            CIN : <span className={'customer-cin-no'}>
                                        <Paragraph
                                            copyable={null !== userProfileDto?.cin && undefined !== userProfileDto?.cin}>{CommonFunction.validateText(userProfileDto?.cin)}</Paragraph></span>
                                        </span>
                                </div>
                            </div>
                        ]}
                        placement="right" onClose={onProfileDrawerClose} open={openProfileDrawer}
                >
                    <div style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        height: '100%'
                    }}>
                        <Row gutter={[8, 8]}>
                            <Col span={24}>
                                <div className="profile-data-div">
                                    <div className="profile-data-icon">
                                        <FontAwesomeIcon icon={faUser}/>
                                    </div>
                                    <div>
                                        <Statistic title="Profile Name"
                                                   value={CommonFunction.validateText(userProfileDto?.customerName)}/>
                                    </div>
                                </div>
                            </Col>
                            <Col span={24}>
                                <div className="profile-data-div">
                                    <div className="profile-data-icon">
                                        <FontAwesomeIcon icon={faIdCard}/>
                                    </div>
                                    <div>
                                        <Statistic title="NIC" formatter={(value: string) => value.replace(',', '')}
                                                   value={CommonFunction.validateText(userProfileDto?.nic)}/>
                                    </div>
                                </div>

                            </Col>
                            <Col span={24}>
                                <div className="profile-data-div">
                                    <div className="profile-data-icon">
                                        <FontAwesomeIcon icon={faCakeCandles}/>
                                    </div>
                                    <div>
                                        <Statistic title="Date of Birth"
                                                   value={null != userProfileDto?.dateOfBirth ? dayjs(userProfileDto?.dateOfBirth).format(YYYY_MM_DD) : NOT_AVAILABLE}/>
                                    </div>
                                </div>

                            </Col>
                            <Col span={24}>
                                <div className="profile-data-div">
                                    <div className="profile-data-icon">
                                        <FontAwesomeIcon icon={faPhone}/>
                                    </div>
                                    <div>
                                        <Statistic title="Contact No."
                                                   formatter={(value: string) => value.replace(',', '')}
                                                   value={CommonFunction.validateText(userProfileDto?.contactNumber)}/>
                                    </div>
                                </div>

                            </Col>
                            <Col span={24}>
                                <div className="profile-data-div">
                                    <div className="profile-data-icon">
                                        <FontAwesomeIcon icon={faEnvelope}/>
                                    </div>
                                    <div>
                                        <Statistic title="Email"
                                                   value={CommonFunction.validateText(userProfileDto?.email)}/>
                                    </div>
                                </div>

                            </Col>
                            <Col span={24}>
                                <div className="profile-data-div">
                                    <div className="profile-data-icon">
                                        <FontAwesomeIcon icon={faUserTie}/>
                                    </div>
                                    <div>
                                        <Statistic
                                            title="Relationship Manager"
                                            formatter={() => renderContent(userProfileDto as UserProfileDto)}
                                        />
                                    </div>
                                </div>

                            </Col>

                        </Row>
                        <Row gutter={[8, 8]} style={{marginTop: 12}}>
                            <Col span={24}>

                                <Button onClick={onChangePasswordClick} className={'change-pw-settings-btn'}>
                                    <div className="user-settings">
                                        <div className="settings-icon">
                                            <FontAwesomeIcon icon={faLock}/>
                                        </div>
                                        <div className="settings-lable">
                                            <span>Change Password</span>
                                        </div>
                                    </div>
                                </Button>

                            </Col>
                        </Row>
                    </div>

                </Drawer>
                <Drawer title="Notifications" placement="right" onClose={onClose} open={open}
                        className="notification-center-drawer"
                        footer={allNotification.unReadCount > 0 ? (
                            <div style={{display: 'flex', justifyContent: 'flex-end'}}>
                                <Button type="link" block onClick={markAllAsRead}>
                                    <span style={{
                                        fontSize: 12,
                                        color: ''
                                    }}>Mark All as Read </span>
                                </Button>
                            </div>
                        ) : null}
                >
                    {isLoggedUserRoleCustomer ?
                        <div>
                            {
                                allNotification && allNotification.notificationList.map((data) => {


                                    return <>
                                        {!data.readNotification ?
                                            <Card title={data.title} size="small" key={data.notificationId}
                                                  style={{marginTop: 10}}>
                                                <p>{data.message}</p>

                                                {
                                                    data.businessFlowName === "sendJointAccountRequestNotification" ||
                                                    data.businessFlowName === "sendJointAccounttemplateAccept" ?
                                                        <Space style={{float: 'right'}}>
                                                            <Button danger
                                                                    onClick={() =>
                                                                        viewJointAccountRequests(data.businessFlowName, data.notificationId)}>View</Button>
                                                        </Space> : ''
                                                }

                                            </Card> : ''
                                        }

                                    </>


                                })
                            }


                        </div> :
                        <></>}

                </Drawer>

                {isLoggedUserRoleCustomer ? <JointAccountTemplateRequest/> : <></>}
                {isLoggedUserRoleCustomer ? <IdleTimeComp logoutClicked={userLogoutFunc}/> : <></>}


            </Header>
        </>
    );
};


export default PageHeader;
